import { IoAdd, IoChevronDown, IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "../App.css"; // <-- make sure fadeSlide is here
import ExcelDownloadButton from "../utils/ExcelDownloader";

export default function CompanyHeader({
  tosearch,
  setToSearch,
  suggestions = [],
  searchCompany,
  filterStatus,
  setFilterStatus,
  handleFilter,
  filter_companies,
}) {
  const navigate = useNavigate();

  console.log(suggestions);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 15,
        padding: "18px 22px",
        backgroundColor: "#ffffff",
        borderRadius: 15,
        boxShadow: "0 6px 20px rgba(0,0,0,0.04)",
        flexWrap: "wrap",
        marginBottom: 20,
      }}
    >
      {/* ---------------- SEARCH INPUT ---------------- */}
      <div style={{ position: "relative", flex: "1 1 240px", minWidth: 240 }}>
        <input
          value={tosearch}
          onChange={(e) => setToSearch(e.target.value)}
          placeholder="Search companies..."
          style={{
            width: "100%",
            padding: "12px 50px 12px 18px",
            borderRadius: 30,
            border: "1px solid #e6e6e6",
            fontSize: 16,
            outline: "none",
            transition: "all 0.3s ease",
            boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
          }}
        />

        <IoSearch
          size={20}
          onClick={() => searchCompany(tosearch)}
          style={{
            position: "absolute",
            right: 18,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#2db7e8",
            cursor: "pointer",
            transition: "color 0.3s ease, transform 0.3s ease",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.color = "#1fa1d6";
            e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.color = "#2db7e8";
            e.currentTarget.style.transform = "translateY(-50%) scale(1)";
          }}
        />

        {/* Suggestions dropdown */}
        {/* {suggestions.length > 0 && (
          <div
            style={{
              animation: "fadeSlide 0.25s ease forwards",
              position: "absolute",
              width: "100%",
              backgroundColor: "#fff",
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              top: "calc(100% + 6px)",
              zIndex: 50,
            }}
          >
            {suggestions.map((s, i) => (
              <div
                key={i}
                onMouseDown={() => {
                  searchCompany(s);
                }}
                style={{
                  padding: "10px 14px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f2f2f2")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                {s}
              </div>
            ))}
          </div>
        )} */}
      </div>

      {/* ---------------- FILTER DROPDOWN ---------------- */}
      <div style={{ position: "relative" }}>
        <select
          value={filterStatus}
          onChange={(e) => {
            setFilterStatus(e.target.value);
            handleFilter(e.target.value);
          }}
          style={{
            padding: "12px 45px 12px 18px",
            fontSize: 16,
            borderRadius: 30,
            border: "1px solid #e6e6e6",
            outline: "none",
            cursor: "pointer",
            backgroundColor: "#fff",
            boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
            transition: "all 0.3s ease",
            appearance: "none",
            minWidth: 200,
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.boxShadow = "0 3px 10px rgba(0,0,0,0.05)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <option value="all">All Companies</option>
          <option value="active">Active Companies</option>
          <option value="inactive">Inactive Companies</option>
        </select>

        

        <IoChevronDown
          size={20}
          style={{
            pointerEvents: "none",
            position: "absolute",
            right: 16,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#9d9d9d",
          }}
        />
      </div>

      <ExcelDownloadButton
        data={filter_companies.map(
          ({
            company_name,
            company_code,
            address,
            city,
            state,
            gst_no,
            mobile_no,
            no_of_devices,
            renewable_date,
          }) => ({
            "Company Name": company_name,
            Code: company_code,
            Address: address,
            City: city,
            State: state,
            "Gst No": gst_no,
            "Mobile No": mobile_no,
            "No. of Devices": no_of_devices,
            "Reneable Date": renewable_date,
          })
        )}
        fileName={`Comapnies`}
      />

      {/* ---------------- ADD COMPANY BUTTON ---------------- */}
      <div
        onClick={() => navigate("/register")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "12px 26px",
          fontSize: 16,
          fontWeight: 500,
          borderRadius: 30,
          cursor: "pointer",
          background: "linear-gradient(90deg, #2db7e8, #1fa1d6)",
          color: "#fff",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
          whiteSpace: "nowrap",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 10px 26px rgba(0,0,0,0.15)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
        }}
      >
        <IoAdd size={20} />
        Add Company
      </div>
    </div>
  );
}
